<template>
  <header class="account-banner">
    <div class="account-banner-inner">
      <div class="account-person">
        <el-image
          :src="basic_data.head || defaultAvatar"
          alt="用户头像"
          fit="cover"
          class="account-avatar"
          ><template slot="error"
            ><img :src="defaultAvatar" alt="默认头像" /></template
        ></el-image>
        <div>
          <h1>
            {{ basic_data.nickname || basic_data.userName || "我的账户" }}
          </h1>
          <el-upload
            :action="API.user.avatar"
            :http-request="uploadAvatar"
            :show-file-list="false"
            accept="image/jpeg,image/png,image/webp"
            :disabled="uploading"
            ><button class="account-avatar-button" :disabled="uploading">
              <img src="@/assets/images/account/02822.svg" alt="" />{{
                uploading ? "上传中…" : "修改头像"
              }}
            </button></el-upload
          >
        </div>
      </div>
      <section class="account-wallet" aria-label="我的钱包">
        <div class="account-wallet-heading">
          <img src="@/assets/images/account/e5ad2.svg" alt="" /><strong
            >我的钱包</strong
          ><router-link to="/center/coupons"
            >优惠券 查看 <img src="@/assets/images/account/47216.svg" alt=""
          /></router-link>
        </div>
        <div class="account-wallet-assets">
          <router-link :to="{ name: 'creatorCenter' }"
            ><strong>分专业查看</strong><span>履约保证金</span></router-link
          ><router-link to="/center/wallet"
            ><strong>{{ balance }}</strong
            ><span>余额</span></router-link
          >
          <div><strong>—</strong><span>冻结金额 · 未提供</span></div>
        </div>
      </section>
    </div>
  </header>
</template>
<script>
import { mapState, mapActions } from "vuex";
import API from "@/tool/api";
import defaultAvatar from "@/assets/images/avatar-default.png";
import { getAvatarFileError } from "@/tool/avatarSubmission.cjs";
export default {
  data: () => ({ API, defaultAvatar, uploading: false }),
  computed: {
    ...mapState({ basic_data: (state) => state.user.basic_data }),
    balance() {
      const value = this.basic_data.balance;
      return value !== null &&
        value !== undefined &&
        value !== "" &&
        Number.isFinite(Number(value))
        ? `¥${value}`
        : "—";
    },
  },
  methods: {
    ...mapActions(["handleChangeAvatar"]),
    async uploadAvatar({ file }) {
      if (this.uploading) return;
      const error = getAvatarFileError(file);
      if (error) {
        this.$message.error(error);
        return;
      }
      this.uploading = true;
      try {
        const result = await this.handleChangeAvatar(file);
        this.$message({ message: result.msg, type: result.type });
      } catch (error) {
        this.$message.error("头像上传失败，请重试");
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
<style scoped>
.account-banner {
  height: 180px;
  background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.55),
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0.4)
    ),
    url("../assets/images/account/b8979.png") center/cover;
}
.account-banner-inner {
  max-width: 1280px;
  margin: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 24px;
  box-sizing: border-box;
}
.account-person {
  display: flex;
  gap: 20px;
  align-items: center;
}
.account-avatar {
  width: 76px;
  height: 76px;
  border: 3px solid #fff;
  border-radius: 50%;
  box-shadow: 0 2px 12px #0002;
}
.account-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.account-person h1 {
  font-size: 26px;
  margin: 0 0 10px;
  color: #24242a;
}
.account-avatar-button {
  height: 40px;
  padding: 0 14px;
  border: 1px solid #e9e9ef;
  background: #ffffffe0;
  border-radius: 100px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}
.account-avatar-button img {
  width: 14px;
  height: 14px;
}
.account-wallet {
  width: 480px;
  box-sizing: border-box;
  padding: 24px;
  border-radius: 18px;
  background: #ffffffe6;
  box-shadow: 0 4px 20px #24213a14;
}
.account-wallet-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #6b5dd5;
  font-size: 15px;
}
.account-wallet-heading > img {
  width: 20px;
  height: 20px;
}
.account-wallet-heading a {
  margin-left: auto;
  font-size: 12px;
  color: #6b5dd5;
  display: flex;
  align-items: center;
  gap: 4px;
}
.account-wallet-heading a img {
  width: 10px;
  height: 10px;
  transform: rotate(-90deg);
}
.account-wallet-assets {
  display: flex;
  align-items: center;
  margin-top: 10px;
  height: 52px;
}
.account-wallet-assets > * {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  color: #24242a;
}
.account-wallet-assets > * + * {
  border-left: 1px solid #6b5dd530;
}
.account-wallet-assets strong {
  font-size: 20px;
}
.account-wallet-assets > a:first-child strong {
  font-size: 15px;
}
.account-wallet-assets span {
  color: #777780;
  font-size: 12px;
}
@media (max-width: 1340px) {
  .account-banner-inner {
    margin: 0 24px;
  }
}
@media (max-width: 700px) {
  .account-banner {
    height: auto;
    min-height: 180px;
  }
  .account-banner-inner {
    margin: 0;
    padding: 24px 16px;
    gap: 20px;
    flex-wrap: wrap;
  }
  .account-wallet {
    width: 100%;
    padding: 18px;
  }
  .account-person h1 {
    font-size: 22px;
  }
}
</style>
